import { Listbox } from "@headlessui/react";
import { CheckIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import FilterDropdown from "components/filters/FilterDropdown";
import CHAINS from "lib/chains";
import { Chain } from "lib/types";
import { useState } from "react";

export type ChainOptions = {
  id: Chain;
  name: string;
}[];

export default function ChainSelectFilter({
  name,
  options,
  value,
  setValue,
}: {
  name: string;
  options: ChainOptions;
  value: Chain[];
  setValue: (val: Chain[] | null) => void;
}) {
  const [selected, setSelected] = useState(value);

  const active = value.length < options.length;
  const displayName =
    `${name} Chain` +
    (active ? ": " + value.map((c) => CHAINS[c].name).join(", ") : "");

  const onSubmit = (close: () => void) => {
    setValue(selected);
    close();
  };
  const onClear = (close: () => void) => {
    setValue(null);
    close();
  };
  return (
    <FilterDropdown
      name={displayName}
      active={active}
      onSubmit={onSubmit}
      onClear={onClear}
    >
      <div>
        <label className="block text-sm text-gray-700">
          {name} Chains
          <Listbox value={selected} onChange={setSelected} multiple>
            <>
              <div className="relative mt-2 overflow-hidden rounded-md border border-gray-300 text-sm shadow-sm">
                <Listbox.Options
                  static
                  className="z-10 max-h-60 w-full overflow-auto bg-white text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                >
                  {options.map((option) => (
                    <Listbox.Option
                      key={option.id}
                      className={
                        "group relative cursor-pointer select-none py-2 pl-8 pr-4 text-gray-900 hover:bg-succinct-teal-20 hover:text-white"
                      }
                      value={option.id}
                    >
                      {({ selected }) => (
                        <>
                          <span className={clsx("block truncate font-normal")}>
                            {option.name}
                          </span>

                          {selected ? (
                            <span
                              className={clsx(
                                "absolute inset-y-0 left-0 flex items-center pl-1.5 text-succinct-teal-20 group-hover:text-white"
                              )}
                            >
                              <CheckIcon
                                className="h-5 w-5"
                                aria-hidden="true"
                              />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </div>
            </>
          </Listbox>
        </label>
      </div>
    </FilterDropdown>
  );
}
